import React from 'react';

//Libs
import { Box, Autocomplete, TextField } from '@mui/material';
import i18next from 'i18next';

// Components
import Errors from '../errors';

//Assets
import Images from '../../../assets/img';

//CSS
import './index.scss';

export const SingleSelectWithSearch = ({
  options,
  displayName,
  classname,
  disabled,
  value,
  handleChange,
  name,
  validation,
  error,
  description,
  placeholder
}) => {
  let val = {};
  let required = {};
  if (validation) {
    val = validation;
    const { rule } = val;
    required = rule?.required;
  }

  const handleDropdownChange = (event, newValue) => {
    const data = {
      value: newValue,
      error: '',
      name: name
    };
    if (required?.isRequired && (!newValue || newValue?.length === 0)) {
      data.error = `${displayName} ${i18next.t('DYNAMIC_FORM.SHARED.ERROR_MESSAGE.IS_REQUIRED')}.`;
      data.isInValid = true;
    }
    handleChange(data);
  };

  return (
    <Autocomplete
      id={name}
      key={name}
      aria-label={displayName}
      disabled={disabled}
      onChange={handleDropdownChange}
      options={options || []}
      value={value || ''}
      getOptionLabel={(option) => option.label ?? option}
      isOptionEqualToValue={(option, value) => {
        if (value) return option.id === value.id;
      }}
      renderOption={(props, item) => (
        <Box component='li' {...props}>
          {item.renderOptionLabel ?? item.label}
        </Box>
      )}
      slotProps={{
        paper: {
          className: 'auto-select-paper'
        }
      }}
      clearIcon={null}
      popupIcon={
        <Box component='img' src={Images.arrowDown} className='popup-icon' />
      }
      renderInput={(params) => (
        <>
          <TextField
            {...params}
            className='user-input-auto-select-field'
            color='primary'
            variant='filled'
            label={
              <>
                {displayName}
                {required?.isRequired && <span className='input__required'> *</span>}
              </>
            }
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              ...params.inputProps,
              placeholder: !value ? placeholder || '' : ''
            }}
          />
          {error ? (
            <Errors
              errorMessaage={error}
              cssName='error-notification-wrapper'
              id='notification-label-id-text-error'
            />
          ) : (
            <div className='input__details'>
              <p className='input__addinal-info -size-s'>{description}</p>
            </div>
          )}
        </>
      )}
    />
  );
};

export default SingleSelectWithSearch;
